<template>
  <!-- forward caller’s light, class, whatever -->
  <Breadcrumb v-bind="$attrs">
    <Breadcrumb.Link
      v-for="(crumb, idx) in crumbs"
      :key="idx"
      :to="crumb.resolvedPath"
      :active="crumb.active"
      :index="idx"
    >
      {{ crumb.name }}
    </Breadcrumb.Link>
  </Breadcrumb>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/Base/Breadcrumb'

interface CrumbMeta {
  name: string
  path: string
  active?: boolean
}

const route = useRoute()
function resolvePath(path: string) {
  return path.replace(/:([^/]+)/g, (_, key) => route.params[key] as string)
}

const crumbs = computed<({ name: string; resolvedPath: string; active?: boolean })[]>(() => {
  const bc = (route.meta.breadcrumb as CrumbMeta[]) || []
  return bc.map(c => ({
    name: c.name,
    active: c.active,
    resolvedPath: resolvePath(c.path)
  }))
})
</script>
